import styled from 'styled-components';
import { useDisplay } from '../../contexts/display';
const Layout = (props: any) => {
  const { isMobile } = useDisplay();

  return <div className={props.className + (isMobile ? ' mobile' : '')}>
      {props.children}
  </div>
}

export const StyledLayout = styled(Layout)`
  display: flex;
  align-items: start;
  justify-content: space-between;
  font-size: 16px;
  padding-top: 0.8rem;
  padding-right: 2rem;
  padding-bottom: 0.8rem;
  width: 100%;

  main {
    margin-left: 1rem;
  }

  &.mobile {
    main {
      margin-left: 0px;

      > div {
        flex-wrap: wrap;
      }
    }
    display: initial;
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
  }
`